module.exports = __webpack_public_path__ + "img/5-1.f3ff8096.png";